import { render, staticRenderFns } from "./yt-summariser.vue?vue&type=template&id=45a60d1d&scoped=true&"
import script from "./yt-summariser.vue?vue&type=script&lang=js&"
export * from "./yt-summariser.vue?vue&type=script&lang=js&"
import style0 from "./yt-summariser.vue?vue&type=style&index=0&id=45a60d1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a60d1d",
  null
  
)

export default component.exports